const initialState = {
	data: [],
	total: 0,
	params: {},
}

const referral = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATEREFERRAL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		default:
			return state
	}
}

export default referral
